<div class="alert error" role="alert" data-tfa="snack-error" animate.enter="snackbar-enter" animate.leave="snackbar-leave">
  <div class="type-icon">
    <mat-icon data-tfa="highlight_off_outline" aria-hidden="true">highlight_off_outline</mat-icon>
  </div>

  <div class="message">
    <span>{{data['error'].message}}</span>

    @if (getCauses()?.length) {
      <ul>
        <ng-container
          [ngTemplateOutlet]="causesAffichage"
          [ngTemplateOutletContext]="{causes:getCauses()}">
        </ng-container>
      </ul>
    }

    <ng-template #causesAffichage let-causes='causes'>
      @for (cause of causes; track cause) {
        <li>{{cause.message}}</li>
        <ul>
          <ng-container
            [ngTemplateOutlet]="causesAffichage"
            [ngTemplateOutletContext]="{causes:cause.causes}">
          </ng-container>
        </ul>
      }
    </ng-template>
  </div>

  <button mat-button class="close" data-dismiss="alert" data-tfa="Close" (click)="snackBarRef.dismiss()" aria-label="fermer">
    <mat-icon data-tfa="cancel">close</mat-icon>
  </button>
</div>
